import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnterprise = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 31",
	fill: "currentColor",
	"aria-hidden": "true",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30.098 0H13.986a1.01 1.01 0 0 0-1.007 1.007v15.105H1.902a1.01 1.01 0 0 0-1.007 1.007v12.084a1.01 1.01 0 0 0 1.007 1.007h28.196a1.01 1.01 0 0 0 1.007-1.007V1.007A1.01 1.01 0 0 0 30.098 0zM2.909 18.126h10.07v10.07H2.909v-10.07zm26.182 10.07H14.993V2.014h14.098v26.182z",
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.014 6.042h2.014v3.021h-2.014V6.042zM24.056 6.042h2.014v3.021h-2.014V6.042zM18.014 11.077h2.014v3.021h-2.014v-3.021zM24.056 11.077h2.014v3.021h-2.014v-3.021zM18.014 16.112h2.014v3.021h-2.014v-3.021zM24.056 16.112h2.014v3.021h-2.014v-3.021zM4.923 20.14h6.042v2.014H4.923V20.14z",
			fill: "#000"
		})
	]
});
const ForwardRef = forwardRef(SvgEnterprise);
export { ForwardRef as ReactComponent };
